module.exports = __webpack_public_path__ + "img/play.39bd2dbf.svg";